import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { menuUrl } from "../manufacturer-list/model/manufacturer-list.constants";
import { editEntry } from "./manufacturer-edit.component.service";
import ManufacturerEditTemplateComponent from "./manufacturer-edit-template.component";
import { getManufacturerInputs } from "../model/manufacturer.modal";


const {
  ALERT_TYPES: { SUCCESS, ERROR },
  MANUFACTURER_ALERTS: { EDIT_ALERT },
} = MESSAGES;

const ManufacturerEditComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct setting payload
    let ManufacturerPayload = {};
    for (let i = 0; i < values.length; i++) {
      ManufacturerPayload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const ManufacturerResponse = await editEntry(
      location?.state?.row?.id,
      ManufacturerPayload
    );

    // INFO : check api response and show relevant alert message
    if (ManufacturerResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: EDIT_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: ManufacturerResponse.message })
      );
    }
  };

  const templateModal = {
    formTriggers,
    formInputs: getManufacturerInputs({
      manufacturer_name: location?.state?.row?.manufacturer_name || "",
      profile_image: location?.state?.row?.profile_image || "",
      status: location?.state?.row?.status || "",
    }),
  };

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <ManufacturerEditTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default ManufacturerEditComponent;
